import { useFormContext, Controller } from 'react-hook-form'
import { TextFieldProps } from '@mui/material'
import { PasswordField } from '../FormControls'

export type RHFPasswordFieldProps = Omit<TextFieldProps, 'onChange'> & {
  name: string
  onChange?: (field: string, value: string) => void
}

export const RHFPasswordField = ({
  name,
  helperText,
  onChange,
  ...other
}: RHFPasswordFieldProps) => {
  const { control, trigger } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <PasswordField
          {...field}
          name={name}
          fullWidth
          value={field.value}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
          onBlur={() => {
            field.onBlur()
            trigger(name)
          }}
        />
      )}
    />
  )
}
